import styled, { css } from 'styled-components';

import { Box } from 'components/Box';
import { colors, fontWeights, fonts, utilityClasses } from 'theme';

export const Root = styled(Box)`
  font-family: ${fonts.sans};
  color: ${colors.greyishBrown};
  * {
    box-sizing: border-box;
    font-family: ${fonts.sans};
  }
  svg {
    box-sizing: content-box;
    pointer-events: none;
  }
  strong {
    font-weight: ${fontWeights.semiBold};
  }
  @page {
    margin-bottom: 0;
    size: auto;
    box-decoration-break: clone;
  }
  ${utilityClasses.map(
    (c) => css`
      .idlst-${c.name.replace(/[aeiou-]/g, '')} {
        ${c.styles}
      }
    `
  )}
`;
